'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('AuthenticatedCtrl', function($translate, $stateParams, userStore, PsobAlertStore,
  sessionService) {

  var self = this;

  this.isEnglish = function() {
    return !($translate.use() === 'fr');
  };

  this.parseResponse = function(responseCode) {
    return responseCode === '502';
  };

  this.showErrorMessage = false;


  this.name = function() {
    return userStore.getFirstName();
  };

  sessionService.validSession().then(function() {
    self.isFullyAuthenticated = true;
  }, function() {
    self.isFullyAuthenticated = false;
  }).finally(function() {
    self.showWelcomeMessage = true;
  });

  this.showErrorMessage = this.parseResponse($stateParams.err);
});
